import "./../../assets/style.css";
import React from "react";
import { Link } from "react-router-dom";
import { Context } from "./../../../App/Components/Context";
import Loading from "./../../../App/Components/Templates/Loading";
import Api from "./../../../App/Components/Utils/Api";
import Time from "./../../../App/Components/Utils/Time";

export default class DashboardDeveloper extends React.Component {
  constructor(props) {
    super(props);
    DashboardDeveloper.contextType = Context;
    this.state = {
      ongoingOpportunityList: [],
      totalOngoingOpportunityList: 0,
      fetchingOngoingOpportunityList: false,
    };
  }

  componentDidMount() {
    this.fetchOngoingOpportunities();
  }

  fetchOngoingOpportunities() {
    this.setState({ fetchingOngoingOpportunityList: true });
    Api.fetch("opportunity.list", undefined, { type: "ongoing", limit: 3 })
      .then(({ status, responseJSON }) => {
        this.setState({ fetchingOngoingOpportunityList: false });
        if (status === 200) {
          this.setState({
            ongoingOpportunityList: responseJSON.data || [],
            totalOngoingOpportunityList: responseJSON.total,
          });
        }
      })
      .catch((reason) => {
        this.setState({ fetchingOngoingOpportunityList: false });
        console.debug(reason);
      });
  }

  render() {
    return (
      <main id="main" className="dashboard">
        <div className="container">
          <div className="stats">
            <div className="row">
              <div className="col-md-4">
                <div className="stat">
                  <div className="heading">
                    {/* <img
                      src="/assets/images/vectors/icons/small_arrow_circle.svg"
                      alt="Info"
                      className="icon"
                    /> */}
                    <span className="title">Total Funding Received</span>
                    <img
                      src="/assets/images/vectors/icons/small_arrow_circle.svg"
                      alt="Info"
                      className="icon"
                    />
                  </div>
                  <div className="body">
                    <span className="data">
                      ₦
                      {parseInt(
                        this.context.user.investment_stat
                          ? this.context.user.investment_stat
                              .total_funding_received
                          : 0
                      )
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>
                  </div>
                  <div
                    style={{ justifyContent: "flex-start" }}
                    className="footing"
                  >
                    {/* <img
                      src="/assets/images/vectors/icons/count.svg"
                      alt="Update"
                      className="icon"
                    /> */}
                    <Link
                      to={{ pathname: "/opportunity/create" }}
                      //   className="nav-link"
                      className="get_funded"
                    >
                      {/* <div className="get_funded"> */}
                      <img
                        src="/assets/images/vectors/icons/get_funded_icon.svg"
                        alt="Info"
                        className="icon"
                      />
                      <p className="get_funded_text">Get Funded</p>
                      {/* </div> */}
                    </Link>
                  </div>
                  {/* <img
                    src="/assets/images/vectors/last_angle_design.svg"
                    alt=""
                    className="angle_design"
                  /> */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat">
                  <div className="heading">
                    {/* <img
                      src="/assets/images/vectors/icons/notice.svg"
                      alt="Info"
                      className="icon"
                    /> */}
                    <span className="title">No Of On-going Projects</span>
                    <img
                      src="/assets/images/vectors/icons/small_arrow_circle.svg"
                      alt="Info"
                      className="icon"
                    />
                  </div>
                  <div className="body">
                    <span className="data">
                      {this.context.user.investment_stat
                        ? this.context.user.investment_stat
                            .no_of_ongoing_project
                        : 0}
                    </span>
                  </div>
                  <div className="footing">
                    {/*<img src="/assets/images/vectors/icons/count.svg" alt="Update" className="icon" />*/}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat">
                  <div className="heading">
                    {/* <img
                      src="/assets/images/vectors/icons/notice.svg"
                      alt="Info"
                      className="icon"
                    /> */}
                    <span className="title">Completed Projects</span>
                  </div>
                  <div className="body">
                    <span className="data">
                      {this.context.user.investment_stat
                        ? this.context.user.investment_stat
                            .no_of_completed_project
                        : 0}
                    </span>
                  </div>
                  <div className="footing">
                    {/*<img src="/assets/images/vectors/icons/count.svg" alt="Update" className="icon" />*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opportunities-container">
            <div className="heading">
              <div className="title">My On-going Projects</div>
              <Link to={{ pathname: "/my-opportunities" }} className="link">
                View More
              </Link>
            </div>
            {/*<div className="opportunities">
              {this.state.fetchingOngoingOpportunityList && <Loading />}
              <div className="row">
                {this.state.ongoingOpportunityList.map((opportunity, index) => (
                  <div key={index} className="col-md-4">
                    <div className="opportunity project">
                      {opportunity.title === "-" && <Loading />}
                      <div className="location">
                        <i className="icon las la-map-marker" />
                        {opportunity.location}
                      </div>
                      <div className="title">{opportunity.title}</div>
                      <div className="amount">
                        <div className="goal">
                          <span className="label">Funding Goal</span>
                          <span className="value">
                            <span className="currency">NGN.</span>
                            {parseInt(opportunity.amount || 0)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                        </div>
                        <div className="raised">
                          <span className="label">Funding Raised</span>
                          <span className="value">
                            <span className="currency">NGN.</span>
                            {parseInt(opportunity.amount_raised || 0)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                        </div>
                      </div>
                      <div className="sponsors">
                        <span className="label">Sponsors</span>
                        <span className="value">
                          {opportunity.crowdy_investments.length}
                        </span>
                      </div>
                      <div className="duration">
                        <span className="label">Funding Duration</span>
                        <span className="value">
                          {Time.timeDifference(
                            opportunity.start_date,
                            opportunity.closing_date
                          )}
                        </span>
                      </div>
                      <Link
                        to={{
                          pathname: "/opportunity/" + opportunity.slug,
                          state: { opportunity: opportunity },
                        }}
                        className="link"
                      >
                        View details
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>*/}
          </div>
        </div>
      </main>
    );
  }
}
